import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { AuthService, HelpersService } from "@evento-ng/libs";
import { TicketService } from "src/app/services/ticket.service";

@Component({
  selector: "app-review-details",
  templateUrl: "./review-details.component.html",
  styleUrls: ["./review-details.component.scss"],
})
export class ReviewDetailsComponent {
  @Input() event: any;
  @Input() invoice: any;
  @Input() showPage: any;
  @Output() detailsMobileOpened = new EventEmitter();
  user: any;
  openPlolicies = false;
  isMobile = false;
  openDetails = false;
  constructor(
    public helpers: HelpersService,
    public ticketService: TicketService,
    private authService: AuthService,
    public translate: TranslateService
  ) {
    this.user = this.authService.user.getValue();
    if (window.screen.width <= 768) {
      this.isMobile = true;
    }
  }

  ngOnChanges() {
    if (this.showPage) {
      this.openDetails = false;
    }
  }

  openDetailsFunction() {
    this.openDetails = true;
    this.detailsMobileOpened.emit(true);
  }
}
